<template>
    <div v-if="data" ref="helpCard" class="job-page__help-card" @click="cardClick">
        <PrismicImage v-if="data.helpCardImage" :image="data.helpCardImage" class="job-page__help-card__image" />
        <p v-if="data.helpCardTitle" class="job-page__help-card__title">{{ data.helpCardTitle?.replace(' ?', '&nbsp;?') }}</p>
        <PrismicRichText v-if="data.helpCardText" :field="data.helpCardText" class="job-page__help-card__text" />
        <div v-if="data.helpCardCtaUrl" class="joy-mt-8">
            <VJoyButton :href="$withLocalePrefix(data.helpCardCtaUrl)" variant="main" rel="nofollow" link data-component-source="help-card">
                {{ data.helpCardCtaLabel }}
            </VJoyButton>
        </div>
    </div>
</template>

<script setup lang="ts">
    import {inject, ref} from 'vue';
    import {PrismicRichText} from '@prismicio/vue';
    import {useRouter, useComponentTracking} from '#imports';
    import {VJoyButton} from '@maltjoy/core-vue';
    import PrismicImage from '~/components/PrismicImage.vue';
    import {JOB_PAGE} from '~/keys';

    const helpCard = ref<HTMLElement | null>(null);

    const {prismicTemplate, jobPageConfig} = inject(JOB_PAGE) || {};

    const data = jobPageConfig?.primary || prismicTemplate?.data;
    const router = useRouter();

    function cardClick() {
        if (!data?.helpCardCtaUrl) return;
        router.push(data.helpCardCtaUrl);
    }

    useComponentTracking(helpCard);
</script>

<style lang="scss">
    .job-page__help-card {
        padding: var(--joy-core-spacing-8) var(--joy-core-spacing-5);
        background-color: var(--joy-color-neutral-20);
        border-radius: var(--joy-core-radius-3);
        border: 1px solid var(--joy-color-neutral-30);
        text-align: center;
        cursor: pointer;
        height: 100%;

        &:hover {
            box-shadow: var(--joy-core-elevation-2);
        }
        &__image {
            width: 40%;
            height: auto;
            max-width: 120px;
            margin-bottom: var(--joy-core-spacing-5);
        }

        &__title {
            color: var(--joy-color-primary-30);
            font-family: var(--joy-font-family-title);
            font-size: var(--joy-font-size-primary-800);
            font-weight: var(--joy-font-weight-bold);
            margin-bottom: var(--joy-core-spacing-5);
        }

        .joy-button {
            padding: 0 var(--joy-core-spacing-6);
            white-space: wrap;
        }
    }
</style>
